import { render, staticRenderFns } from "./table-unassigned-processes.vue?vue&type=template&id=5cd7aca1&scoped=true&"
import script from "./table-unassigned-processes.vue?vue&type=script&lang=js&"
export * from "./table-unassigned-processes.vue?vue&type=script&lang=js&"
import style0 from "./table-unassigned-processes.vue?vue&type=style&index=0&id=5cd7aca1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd7aca1",
  null
  
)

export default component.exports